<template>
  <div>
    <div v-if="model.active">
      <div class="card">
        <div class="py-1">
          <fixed-header id="sticky-header">
            <div class="row">
              <div class="col-md-1" />
              <div class="container-fluid col-md-3 my-auto">
                <a href="/" class="navbar-brand mr-0 mr-md-2 logo">
                  <!-- <span class="logo-lg" v-if="!model.logo"> -->
                    <img src="@assets/Logomark2000.png" alt height="45" />
                  <!-- </span> -->
                  <!-- <span class="logo-lg" v-else>
                    <img :src="model.logo" alt height="24" />
                  </span> -->
                </a>
              </div>
              <div class="col-md-8 row font-weight-normal">
                <div class="row col-md-3">
                  <div class="media pt-2">
                    <Avatar 
                      :data="model.user_id"
                      :avatarField="model.user_id.avatar"
                      customClass="mr-2 avatar-sm rounded-circle"
                      padding="0" 
                      customSize="30"
                      customFont="20"
                      alt="shreyu"
                    />
                  </div>
                  <div class="my-auto">
                    <div>{{ model.user_id && model.user_id.full_name ? model.user_id.full_name : '-' }}</div>
                    <div class="text-muted">{{ computedAccessType ? computedAccessType : '-' }}</div>
                  </div>
                </div>
                <div class="row col-md-7 border-left my-auto">
                  <div class="col-md-4">
                    <div v-if="model.user_id && model.user_id.company_name"><i class="mr-2 uil-envelope"></i>{{ model.user_id.company_name }}</div>
                    <div v-else-if="computedAccessType == 'Administration'"><i class="mr-2 uil-envelope"></i>Jinz.ai</div>
                    <div v-else class="ml-md-4 text-muted">{{ $t('empty_notification') }}</div>
                    <div class="ml-md-4 text-muted">{{$t('job.form.company.label')}}</div>
                  </div>
                  <div class="col-md-4">
                    <div v-if="model.user_id && model.user_id.email"><i class="mr-2 uil-envelope"></i>{{ model.user_id.email }}</div>
                    <div v-else class="ml-md-4 text-muted">{{ $t('empty_notification') }}</div>
                    <div class="ml-md-4 text-muted">{{$t('job.form.email')}}</div>
                  </div>
                  <div class="col-md-4">
                    <div v-if="model.user_id && model.user_id.contact_no"><i class="mr-2 uil-phone"></i>{{ model.user_id.contact_no }}</div>
                    <div v-else class="ml-md-4 text-muted">{{ $t('empty_notification') }}</div>
                    <div class="ml-md-4 text-muted">{{$t('job.form.phone_no')}}</div>
                  </div>
                </div>
                <div class="col-sm-2 my-auto">
                  <div>
                    <b-nav-item-dropdown
                      id="globe-tooltip"
                      right
                      variant="black"
                      class="dropdown d-none d-lg-block"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <div><i class="mr-2 uil-globe"></i>{{ model.user_id && model.user_id.lang ? model.user_id.lang : "-" | formattedLanguage}}<i class="mr-2 uil-angle-down"></i></div>
                      </template>
                      <b-tooltip target="globe-tooltip" placement="left"
                        >Change language</b-tooltip
                      >
                      <b-dropdown-item href="javascript:void(0);" class="notify-item"
                        @click="toggleLanguage('us')">
                        <img
                          src="@assets/images/flags/us.jpg"
                          alt="user-image"
                          class="mr-2"
                          height="12"
                        />
                        <span class="align-middle">English (US)</span>
                      </b-dropdown-item>

                      <b-dropdown-item href="javascript:void(0);" class="notify-item"
                      @click="toggleLanguage('jp')">
                        <img
                          src="@assets/images/flags/japan.jpg"
                          alt="user-image"
                          class="mr-2"
                          height="12"
                        />
                        <span class="align-middle">Japanese</span>
                      </b-dropdown-item>

                    </b-nav-item-dropdown>
                  </div>
                  <div class="ml-md-4 text-muted">Language</div>
                </div>
              </div>
            </div>
          </fixed-header>
        </div>
      </div>
      <div v-if="model.company_id" class="row d-flex justify-content-center">
        <div class="col-md-7">
          <div >
            <span class="mt-1 mb-2 text-right badge  badge-pill float-right"
              :class="model.active ? 'badge-success' : 'badge-danger'"
            >{{ model.active ? $t('job.badges.active') : $t('job.badges.deactivated') }}</span>

            <span class="mt-1 mb-2 mx-1 text-right badge badge-pill float-right badge-danger"
              v-if="!model.remaining"
            >{{$t('job.badges.no_slot')}}</span>
          </div>

          <div class="media mb-3">
            <Avatar 
              :data="model.company_id" 
              customClass="mr-3 avatar-lg rounded"
              padding="0" 
              alt="shreyu"
            />
            <div class="media-body">
                <h6 class="font-weight-normal mt-1 mb-1">
                  {{model.company_id.name}}
                </h6>
                <h5 class="mt-1 mb-0">{{model.title}}</h5>
                <!-- <p class="text-muted">{{model.city}}, {{model.country}}</p> -->

                <p class="text-muted">
                  <span class="mr-2" v-if="model.company_id.contact_no"><i class="mr-2 uil-phone"></i> {{model.company_id.contact_no}} </span>
                  <span class="mr-2" v-if="model.company_id.email"><i class="mr-2 uil-envelope"></i> {{model.company_id.email}} </span>
                  <span class="mr-2" v-if="model.company_id.website"><i class="mr-2 uil-globe"></i> {{model.company_id.website}} </span>
                </p>
                
            </div>
          </div>
          <div class="border-bottom-solid border-top-solid">
            <div class="row px-5 mt-3">
              <div class="col-md-3 mb-3">
                <div class="text-muted">{{$t('job.form.employment_status')}}</div>
                <div v-if="model.employment_type">{{ computedEmploymentType }}</div>
                <div v-else class="text-muted">-</div>
              </div>
              <div class="col-md-3 mb-3">
                <div class="text-muted">{{ model.use_min_max_salary ? $t('job.form.salary_range') : 'Salary' }}</div>
                <div v-if="model.use_min_max_salary">{{ model.min_salary ? model.min_salary.$numberDecimal : 0 | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }} - {{ model.max_salary ? model.max_salary.$numberDecimal : 0 | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }}</div>
                <div v-else-if="model.salary">{{ computedSalaryFormatter }}</div>
                <div v-else class="text-muted">-</div>
              </div>
              <div class="col-md-3 mb-3">
                <div class="text-muted">{{$t('job.form.location')}}</div>
                <div v-if="model.city || model.country">{{ computedLocation }}</div>
                <div v-else class="text-muted">-</div>
              </div>
              <div class="col-md-3 mb-3">
                <div class="text-muted">{{$t('job.form.reference_no.label')}}</div>
                <div v-if="model.reference_no">{{ model.reference_no }}</div>
                <div v-else class="text-muted">-</div>
              </div>
              <div class="col-md-3 mb-3">
                <div class="text-muted">{{$t('job.form.english.label')}}</div>
                <div v-if="model.english_level">{{ model.english_level }}</div>
                <div v-else class="text-muted">-</div>
              </div>
              <div class="col-md-3 mb-3">
                <div class="text-muted">{{$t('job.form.job_type.label')}}</div>
                <div v-if="model.job_type">{{ model.job_type }}</div>
                <div v-else class="text-muted">-</div>
              </div>
              <div class="col-md-3 mb-3">
                <div class="text-muted">{{$t('job.form.industry.label')}}</div>
                <div v-if="model.industry_id">{{ model.industry_id | formattedIndustry }}</div>
                <div v-else class="text-muted">-</div>
              </div>
            </div>
          </div>
          <div v-if="model.summary" class="border-bottom-solid mt-3" v-html="model.summary"></div>
          <div v-if="model.description" class="border-bottom-solid mt-3" v-html="model.description"></div>
          <div v-if="model.remarks" class="border-bottom-solid mt-3" v-html="model.remarks"></div>
        </div>
        <!-- future purposes -->
        <div class="col-md-3">
          <!-- <button class="btn btn-dark mr-1 mb-3 mb-sm-0 col-md-12">
            Apply Via Linkedin
          </button>
          <div class="text-center my-4 text-line"><span>or Apply with</span></div> -->
          <!-- <button 
            class="btn btn-soft-dark mr-1 mb-3 mb-sm-0 col-md-12"
            style="height: 120px;"
          >
            Upload Resume*
          </button> -->
          <b-form-group id="fileInput" class="dragdrop mb-5">
            <b-form-file
              v-model="candidateFiles"
              multiple
              accept=".docx, .pdf, .doc"
              placeholder="Upload Resume*"
            />
          </b-form-group>
          <TextField
            v-model="candidateApplication.name"
            placeholder="Enter Full Name"
            label="Full Name"
            class="col-md-12 mt-3"
            :error="!candidateApplication.name && isEmpty"
            :errorMessage="!candidateApplication.name && isEmpty ? 'Please Input Full Name' : false"
          />

          <TextField 
            v-model="candidateApplication.email"
            placeholder="Enter Email ID"
            label="Email ID"
            class="col-md-12 mt-3'"
            type="email"
            :error="!candidateApplication.email && isEmpty"
            :errorMessage="!candidateApplication.email && isEmpty ? 'Please Input Email' : false"
          />

          <TextField
            v-model="candidateApplication.contact_no"
            placeholder="Enter Mobile Number"
            label="Mobile Number"
            class="col-md-12 mt-3"
            type="number"
            :error="!candidateApplication.contact_no && isEmpty"
            :errorMessage="!candidateApplication.contact_no && isEmpty ? 'Please Input Mobile Number' : false"
          />

          <div class="d-flex flex-row-reverse col-md-12">
            <router-link
              class="btn btn-dark mr-1 mb-3 mb-sm-0 col-md-8"
              tag="button"
              to=""
              @click.native="onSubmitCandidate"
            >
              Submission
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="account-pages my-5">
      <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-5 col-8">
          <div class="text-center">
            <div>
              <div class="text-h1 bold">JINZ.AI</div>
              <div class="text-h5">PEOPLE + AI</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <h6 v-if="model.company_id" class="mt-3 bold">{{ model.company_id.name }} | {{ model.title }}</h6>
          <h3 class="mt-3 bold">This job is currently unavailable</h3>
          <div class="text-h6 emphasized mt-4">Please contact our recruiter if you need further support.</div>
          <div class="text-h5"> <b-icon icon="person"/> 
            Recruiter: {{ model.user_id && model.user_id.full_name ? model.user_id.full_name : '-' }}
          </div>
          <div class="container">
            <div class="text-h6" v-if="model.user_id && model.user_id.contact_no"><i class="mr-2 uil-phone">
              Phone:</i>{{ model.user_id.contact_no }} | <i v-if="model.user_id && model.user_id.email" class="mr-2 uil-envelope">Email:</i>{{ model.user_id.email }}
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
/* import PlaceCandidateModal from '@components/modals/placeCandidateModal' */
import NProgress from 'nprogress/nprogress'
import { required } from 'vuelidate/lib/validators'
import error from '@utils/error'
import Avatar from '@components/avatar'

export default {
  mixins: [FormMixin],
  components: {
    TextField: () => import('@components/form/textfield.vue'),
    Avatar
  },
  data(){
    return {
      manual: true,
      finalModel:{
        user:{},
        work_experiences:[],
        educations:[],
        skills:[]
      },
      model:{
        active:true,
        company_id:{
          name:''
        },
        currency_id:{
          symbol:''
        }
      },

      feedbacks:[],
      application:[],
      candidate:[],

      candidates:[],
      applicants:[],
      placed_applicants:[],
      rejected_applicants:[],
      applicant:{},
      new_applicant:{
        whatId:'candidate_id',
        candidate_id:{
          avatar_path:''
        },
        prospect:{
          avatar_path:''
        }
      },
      applicantLoading:false,
      placeApplicantLoading:false,
      rejectedApplicantLoading:false,
      loadSelectCandidate:false,
      status_option:[
        /* { value: null, text: 'Pending' }, */
        { value: 'Sent', text: 'Sent' },
        { value: 'First Interview', text: 'First Interview' },
        { value: 'Second Interview', text: 'Second Interview' }/*,
        { value: 'Offered', text: 'Offered' } ,
        { value: 'Placed', text: 'Placed' }, */
      ],
      candidateApplication: {
        name: '',
        email: '',
        contact_no: ''
      },
      validations: {
        candidateApplication:{
          name: { required },
          email: { required },
          contact_no: { required },
        }
      },
      candidateFiles: [],
      isEmpty: false
    }
  },
  methods: {
    ...mapActions('job', ['viewJob']),
    ...mapActions('candidate', ['sumbitCandidate']),
    load(){
      this.viewJob({
        token:this.$route.query.token
      }).then(data => {
        this.model = data.data
      })
    },
    toggleLanguage(lang){
			this.$cookie.set('language', lang, 7);
			this.$i18n.locale = lang
			this.$store.dispatch('user/updateLanguage', {lang:lang})
      this.model.user_id.lang = lang
		},
    capitalizeString(str) {
      let string = str || ''
      return `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`
    },
    async onSubmitCandidate() {
      let { name, email, contact_no } = this.candidateApplication
      let { company_id, title, user_id } = this.model
      user_id.full_name
      if((email && email == user_id.email) || (name && name == user_id.full_name)){
        return error.errorHandler({ message: "The link generator cannot apply for this position." }, this.$bvToast)
      }else{
        if(!name || !email || !contact_no) {
          this.isEmpty = true
          return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
        }else{
          NProgress.start()
          this.isEmpty = false
          var formData = new FormData();
          if(this.candidateFiles){
            this.candidateFiles.forEach((file) => {
              formData.append("files", file);
            });
          }
          formData.append("candidate_name", name);
          formData.append("candidate_email", email);
          formData.append("candidate_contact_no", contact_no);
          formData.append("company_name", company_id.name);
          formData.append("job_title", title);
          formData.append("lang", user_id.lang);
          formData.append("email", user_id.email);
    
          await this.sumbitCandidate(formData).then(() => {
            NProgress.done()
            this.$bvToast.toast('Candidate Application successfully Submitted!', {
              variant: 'success',
              title: "Notification"
            });
          }).catch(err => {
            this.errorMessage = err.errorMessage
            NProgress.done()
          })
        }
      }
    }
  },
  beforeMount() {
    this.load()
  },
  filters: {
    formattedLanguage(lang){
      return lang == 'us' ? 'English' : lang == 'jp' ? 'Japanese' : lang
    },
    formattedIndustry(val){
      let name = []
      for(let key in val){
        name.push(val[key].name)
      }

      return name.join(', ') || "-"
    }
  },
  computed:{
    currency_symbol(){
      var symbol = ""
      if(this.model.currency_id){
        symbol = this.model.currency_id.symbol
      }
      return symbol
    },
    computedLocation(){
      let { city ,  country } = this.model
      let loc = []
      city ? loc.push(city) : ''
      country ? loc.push(country) : ''

      return loc.join(', ')
    },
    computedEmploymentType() {
      let model = this.model || {}
      let employmentType = ''

      if (model.employment_type) {
        employmentType = `${this.capitalizeString(model.employment_type)}`.replace('_', '-')
      }
      else employmentType = '-'

      return employmentType
    },
    computedSalaryFormatter() {
      let model = this.model || {}
      let salary = model.salary || ''

      if (salary && salary.length > 30) {
        salary = 0
      }

      return salary
    },
    computedAccessType() {
      let model = this.model || {}
      let user = model.user_id || {}
      let userRole = user.role || {}

      return userRole && userRole.name ? userRole.name : user.access_type
    }
  }
}
</script>
<style lang="scss" scoped>
  .border-bottom-solid {
    border-bottom-style: solid;
    border-color: #DEDEDE;
  }
  .border-top-solid {
    border-top-style: solid;
    border-color: #DEDEDE;
  }
  .text-line {
    width: 100%; 
    text-align: center; 
    border-bottom: 1px solid #000; 
    line-height: 0.1em;
    margin: 10px 0 20px; 
  }   
  .text-line span { 
    background:#edeff4;
    padding:0 10px; 
  }
  #fileInput.dragdrop .custom-file,
  #fileInput.dragdrop .custom-file-input {
    height: 120px;
    cursor: pointer;
  }
  #fileInput.dragdrop .custom-file-label {
    border: 0;
    border: 2px dashed #404040;
    /* height: 150px; */
    /* padding: 50px; */
    /* line-height: 142px; */
    text-align: center;
    color: #404040;
    padding-top: 65px;
    padding-bottom: 90px;
  }
  #fileInput.dragdrop .custom-file:hover .custom-file-label {
    background: #404040;
    color: #fff;
  }
  #fileInput.dragdrop .custom-file-label::after {
    display: none;
  }
  .account-pages {
    margin-top: 10rem !important;
  }
  .emphasized {
    font-style: italic;
  }
  .bold {
    font-weight: bold;
  }
  .text-h1 {
    font-size: 2.5rem;
  }
  .text-h2 {
    font-size: 1.7rem;
  }
  .text-h5 {
    font-size: 1.2rem;
  }
  .text-h6 {
    font-size: 1rem;
  }
  
</style>

